import i18n from 'lib/i18next';
import Vehicle from 'types/Vehicle';
import { AdInfo } from 'lib/CarGurusAds';

import { getClientFirstTouchedTimestamp } from 'lib/EventLogger/LocalStorageStore';

export const PAGE_VIEW_EVENT = 'PageView';
const PURCHASE_EVENT = 'Purchase';
const LEAD_EVENT = 'Lead';
export const VDP_VIEWED_EVENT = 'ViewContent';
export const FAVORITE = 'AddToWishlist';

export type PartnerType = 'dealer_direct' | 'classified' | 'metasearch';

export const CPL_VALUE = 0.01;
export const CURRENCY = 'USD';
export const CONTENT_TYPE = 'vehicle';

export function track(eventName: string, options = {}): void {
  fbq('track', eventName, options);
}

export function trackPageView(): void {
  track(PAGE_VIEW_EVENT);
}

export function trackVdpView(
  vehicle: Vehicle,
  zip: string | undefined,
  adInfo: AdInfo | undefined
): void {
  track(VDP_VIEWED_EVENT, {
    content_type: CONTENT_TYPE,
    postal_code: vehicle.zip,
    price: vehicle.price,
    currency: CURRENCY,
    value: CPL_VALUE,
    content_name: 'detail',
    content_ids: [`${vehicle.vin}`],
    // eslint-disable-next-line camelcase
    isNew: adInfo?.age_type === 'new' || adInfo?.age_type === 'newplus',
    isCPO: adInfo?.cpo,
    locale: `${i18n.language}_US`,
    user_zipcode: zip,
    firstVisit: getClientFirstTouchedTimestamp(),
    make: vehicle.make,
    model: vehicle.model,
    event_name: 'ViewContent',
  });
}

export function trackLeadSubmit(
  vehicle: Vehicle,
  postal: string | undefined,
  leadId: string,
  zip: string | undefined
): void {
  const sharedLeadSubmissionEventParams = {
    currency: CURRENCY,
    content_ids: [vehicle.vin],
    content_name: 'conversion',
    content_type: CONTENT_TYPE,
    firstVisit: getClientFirstTouchedTimestamp(),
    locale: `${i18n.language}_US`,
    orderId: `${vehicle.vin}@${leadId}`,
    postal_code: postal || vehicle.zip,
    price: vehicle.price,
    user_zipcode: zip || vehicle.zip,
    value: CPL_VALUE,
  };

  track(PURCHASE_EVENT, {
    ...sharedLeadSubmissionEventParams,
    lead_type: 'email',
    // eslint-disable-next-line camelcase
    partner_type: vehicle.partner_type,
  });

  track(LEAD_EVENT, {
    ...sharedLeadSubmissionEventParams,
    event_name: 'Lead',
  });
}

export function trackFavorite(): void {
  track(FAVORITE, {
    content_type: CONTENT_TYPE,
    currency: CURRENCY,
  });
}

export default {
  track,
  trackPageView,
  trackVdpView,
  trackLeadSubmit,
  trackFavorite,
};
